import * as categories from "./categories";
import * as orders from "./orders";
import * as giftOrders from "./gift-orders";
import * as exchangeOrders from "./exchange-orders";
import * as products from "./products";
import * as setting from "./setting";

export const shop = {
    ...categories,
    ...orders,
    ...giftOrders,
    ...exchangeOrders,
    ...products,
    ...setting
}